import { Transition } from '@headlessui/react';
import { ChangeEvent, Fragment, memo, useEffect, useState } from 'react';

import { Button, Card, IconSvg, Input, Text } from '@/lib/v2/components';
import { CloseIcon, EditPencilIcon } from '@/lib/v2/icons/outline';

type RenameItemProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  placeholder?: string;
  rightClick: number;
  topClick: number;
  value?: string;
  isLoading?: boolean;
  onActionButton?: (value: string) => void;
  actionButtonText: string;
};

const RenameItem = ({
  isOpen,
  onClose,
  title,
  rightClick,
  topClick,
  placeholder,
  value,
  isLoading,
  actionButtonText,
  onActionButton,
}: RenameItemProps) => {
  const [inputValue, setInputValue] = useState('');

  const right = `${rightClick + 8}px`;
  const top = `${topClick}px`;

  useEffect(() => {
    if (value) setInputValue(value);
  }, [value]);

  return (
    <Transition
      appear
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      show={isOpen}
    >
      <div className="fixed z-10 w-[380px]" style={{ left: right, top }}>
        <Card>
          <div className="flex w-full flex-col items-center gap-3 text-center">
            <button
              className="absolute right-4 top-4 z-10 rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2
                  focus:ring-emblue-primary focus:ring-offset-2"
              type="button"
              onClick={() => onClose()}
            >
              <span className="sr-only">Close</span>
              <IconSvg svgComponent={<CloseIcon />} />
            </button>
            <div className="flex w-full flex-col">
              <div className="flex items-center gap-2">
                <EditPencilIcon />
                <Text>{title}</Text>
              </div>
              <Input
                placeHolder={placeholder}
                value={inputValue}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setInputValue(e.target.value)}
              />
            </div>
            <div className="flex w-full">
              <Button
                disabled={inputValue === value || inputValue.length === 0}
                isLoading={isLoading}
                onClick={() => onActionButton?.(inputValue)}
              >
                {actionButtonText}
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </Transition>
  );
};

export default memo(RenameItem);
